export const PlayTriangle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#0A819F"
      d="m3.215.21 9 5.5c.437.282.719.782.719 1.282 0 .531-.282 1.031-.72 1.281l-9 5.5c-.468.281-1.062.313-1.53.031-.47-.25-.75-.75-.75-1.312v-11c0-.531.28-1.031.75-1.281a1.495 1.495 0 0 1 1.53 0Z"
    />
  </svg>
);
